<template>
  <div class="pcdetails">
    <el-backtop target=".pcdetails"></el-backtop>
    <div class="pchome-headerdet">
      <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
    </div>
    <position-bar :productc_nav="productc_nav" :positionNav="positionNav">
      <div class="productc-right" v-if="detail.template_id == 1 || detail.template_id == 3">
<!--        <div class="right-detail" :style="acindex == 1 ? 'color:' + nav_color : ''" @click="switchTab(1)">-->
<!--          {{ xiangq }}-->
<!--        </div>-->
<!--        <div class="right-parameter" :style="acindex == 2 ? 'color:' + nav_color : ''" @click="switchTab(2)">-->
<!--          {{ canshu }}-->
<!--        </div>-->
<!--        <div class="right-instructions" :style="acindex == 3 ? 'color:' + nav_color : ''" @click="switchTab(3)">-->
<!--          Download-->
<!--        </div>-->
        <!--				<div class="right-instructions" :style="acindex == 4 ? 'color:' + nav_color : ''" @click="switchTab(4)">-->
        <!--					Download-->
        <!--				</div>-->
        <div class="right-detail" :style="acindex == 1 ? 'color:#e62129' : ''" @click="switchTab(1)">
          {{ xiangq }}
        </div>
        <div class="right-parameter" :style="acindex == 2 ? 'color:#e62129' : ''" @click="switchTab(2)">
          {{ canshu }}
        </div>
        <div class="right-instructions" :style="acindex == 3 ? 'color:#e62129' : ''" @click="switchTab(3)">
          Download
        </div>
      </div>
    </position-bar>
    <!--		<div style="padding:10px 0;opacity:0" v-if="productc_nav">-->
    <!--			<div class="productc-left">-->
    <!--				{{detailnames}}-->
    <!--			</div>-->
    <!--		</div>-->
    <!--		<div class="linesd"></div>-->
    <div v-if="detail.template_id != 2" style="width: 100vw;min-height: 100vh;">
      <div class="righttex opacity-0" v-if="acindex == 1 && detail.template_id == 1" :class="showProduct ? 'opacity-1' : ''">
        <!--			<div class="detailvideo" v-if="detavideosea">-->
        <!-- 旧版 上线删除 -->
        <!--                <div class="detailvideo" v-if="youtube_id">-->
        <!--				<myVideo :src="detavideo" :poster="poster"></myVideo>-->
        <!-- <video controls controlslist="nodownload" :poster="poster" id="bigvideo" :src="detavideo" ></video> -->
        <!-- <div class="contright-icon" @click="optionssvid" v-if="!video_play">
          <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pchomeplay.svg" />
        </div> -->
        <!--                  <div class="cover-container" @click="toYoutube">-->
        <!--                    <img :src="poster" alt="">-->
        <!--                    <img class="icon-play"-->
        <!--                         src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pchomeplay.svg" />-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div v-html="htmlcontent" class="html_div"></div>-->
        <detailContent ref="detailContentRef" :detail="detail"></detailContent>
      </div>
      <div v-if="acindex == 1 && detail.template_id == 3">
        <specialEndo v-if="detail.template_name == 'endo'"></specialEndo>
        <specialPtE v-if="detail.template_name == 'pt-e'"></specialPtE>
      </div>
      <div class="parametersea" v-if="acindex == 2">
        <div class="parameter-header">
          <div class="parahea-left">
            <div class="parahea-leftname">
              {{ detailnames }}
            </div>
            <p v-for="(item, index) in contenttitle">{{ item }}</p>
          </div>
          <div class="parahea-right">
            <img :src="parameter" />
          </div>

        </div>
        <div class="parameter-foo" v-for="(item, index) in productargcont" :key="index">
          <div class="parafoo-left">
            {{ item.title }}
          </div>
          <div class="parafoo-right">
            <div v-html="item.content"></div>
            <!-- <div>这里是参数的具体数值文案，可以自定义内容文案</div>
            <div>这里是参数的具体数值文案，可以自定义内容文案，可以自定义多少行</div>
            <div>反正具体信息你们后期后台去修改</div>
            <div>按照这个规范排版即可</div> -->
          </div>
        </div>
      </div>
      <!--		<div class="instructions" v-if="acindex == 3" v-for="(item, index) in filenavto" :key="index">-->
      <div class="instructions" v-if="acindex == 3">
        <detailDownload :detail="detail"></detailDownload>
        <!--        			<div class="instructions-cont">-->
        <!--        				<div class="cont-hea">{{ vidcenter }}</div>-->
        <!--        				<button class="cont-but"-->
        <!--        					@click="navtoshiyan(Array.isArray(channel_file) && channel_file.length ? channel_file[index].file : item.file)">-->
        <!--        					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcdetailsimg/pdf.svg" />-->
        <!--        					{{ item.file_title }}. PDF-->
        <!--        				</button>-->
        <!--        				<div class="cont-title">-->
        <!--        					{{ casesha }}: {{ filetitle }}{{ videonavall }}-->
        <!--        				</div>-->
        <!--        			</div>-->
      </div>

      <div class="download" v-if="acindex == 4">
        <div class="download-container">
          <div class="publicize">
            <span>{{ detailnames }} Videos</span>
            <span v-if="publicize.video" class="download-btn"
                  @click="downloadFileAll(publicize.video, detailnames + '宣传视频', 1)">Download All<i
                class="el-icon-download"></i></span>
          </div>
          <div class="picture-list">
            <div class="item" v-for="(item, index) in publicize.video">
              <div class="image" v-if="item.image">
                <img class="svg" :src="item.image" alt="">
              </div>
              <div class="image bcg" v-else>
                <div class="image_title">{{ item.title }}</div>
              </div>
              <div class="bex">
                <span class="bex_txt">{{ item.title }}</span>
                <span class="download-btn"
                      @click="downloadFile(item.video, detailnames + '宣传视频_' + (index + 1))">Download<i
                    class="el-icon-download"></i></span>
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="publicize">
            <span>{{ detailnames }} Brochures</span>
            <span v-if="publicize.resource" class="download-btn"
                  @click="downloadFileAll(publicize.resource, detailnames + '宣传资料', 2)">Download All<i
                class="el-icon-download"></i></span>
          </div>
          <div class="picture-list">
            <div class="item" v-for="(item, index) in publicize.resource">
              <div class="image" v-if="item.image">
                <img class="svg" :src="item.image" alt="">
              </div>
              <div class="image bcg" v-else>
                <div class="image_title">{{ item.title }}</div>
              </div>
              <div class="bex">
                <span class="bex_txt">{{ item.title }}</span>
                <span class="download-btn"
                      @click="downloadFile(item.resource, detailnames + '宣传资料_' + (index + 1))">Download<i
                    class="el-icon-download"></i></span>
              </div>

            </div>
          </div>
          <div class="line"></div>
          <div class="publicize">
            <span>{{ detailnames }} Images</span>
            <span v-if="publicize.images.length > 0" class="download-btn"
                  @click="downloadImageAll(publicize.images, detailnames + '产品图片')">Download All<i
                class="el-icon-download"></i></span>
          </div>
          <div class="picture-list">
            <div class="item" v-for="(item, index) in publicize.images">
              <div class="image">
                <img :src="item.image" alt="">
              </div>
              <div class="bex">
                <span class="bex_txt">{{ item.title }}</span>
                <span class="download-btn"
                      @click="downloadImage(item.image, detailnames + '产品图片_' + (index + 1))">Download<i
                    class="el-icon-download"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detailTips ref="detailTipsRef" :detail="detail" v-else></detailTips>

    <footers ref=is_change></footers>
  </div>
</template>

<script>
import 'lib-flexible/flexible.js'
import myVideo from '../../common/myvideo/img/myVideo.vue'
import { session } from '../../storage/storage.js';
import headers from '../../common/header.vue'
import footers from '../../common/footers.vue'
import positionBar from '@/components/position-bar.vue'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import utils from '../../api/utils.js'
import detailDownload from './components/detail-download.vue'
import detailTips from './components/detail-tips.vue'
import detailContent from "./components/detail-content.vue";
import specialEndo from "@/components/special/pc/endo/index.vue"
import specialPtE from "@/components/special/pc/pt-e/index.vue"

export default {
  data() {
    return {
      video_play: false,
      productc_nav: false,
      videonavall: '',
      casesha: '',
      vidcenter: '',
      id: '',
      xiangq: '产品详情',
      canshu: '产品参数',
      shuom: '产品说明',
      detailid: 1,
      navheader: true,
      heshow: false,
      show: false,
      playli: true,
      playri: true,
      acindex: 1,
      detailnames: '',
      htmlcontent: '',
      parameter: '',
      contenttitle: '',
      productargcont: '',
      fiilecontent: '',
      filetitle: '',
      poster: '',
      detavideo: '',
      detavideosea: true,
      options: [{
        value: '选项1',
        label: '啄木鸟官网'
      }, {
        value: '选项2',
        label: '啄木鸟官网1'
      }, {
        value: '选项3',
        label: '啄木鸟官网2'
      }, {
        value: '选项4',
        label: '啄木鸟官网3'
      }, {
        value: '选项5',
        label: '啄木鸟官网4'
      }],
      optionslang: [{
        valuelang: '选项1',
        labellang: 'CN'
      }, {
        valuelang: '选项2',
        labellang: 'EN'
      }],
      value: '',
      valuelang: '',
      filenavto: [],
      list_img: [
        //       { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic.png",id:1,is_cover:false},
        //       { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic2.png",id:2,is_cover:false},
        //       { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic3.png",id:3,is_cover:false},
        //       { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic4.png",id:4,is_cover:false},
        //       { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic5.png",id:5,is_cover:false},
        // { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic.png",id:6,is_cover:true},
        // { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic2.png",id:2,is_cover:false},
        // { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic3.png",id:3,is_cover:false},
        // { url: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic4.png",id:4,is_cover:false},
      ],
      scroll_height: 0,
      is_mounted: false,
      nav_color: session.get('channel_id') == 1 ? '#e62129' : session.get('channel_id') == 2 ? '#1a4698' : '#5f5d5d',
      showProduct: false,
      channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
      pageType: '',
      positionNav: [
        {
          title: 'Home',
          path: '/pchome'
        },
        {
          title: 'Products',
          path: '/pcproduct'
        },
        {
          title: '',
          path: ''
        },
      ],
      isData: false,
      publicize: {
        video: '',
        resource: '',
        images: []
      },
      picture: [],
      channel_file: [],
      resource: '',
      youtube_id: '',
      en_images_data: [],
      en_resource_data: [],
      en_video_data: [],
      detail: {
        template_id: 1,
      }
    }
  },
  watch: {
    channel_id(value) {
      this.nav_color = value == 1 ? '#e62129' : value == 2 ? '#1a4698' : '#5f5d5d'
    }
  },
  created() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.$router.push({ path: './phdetails', query: this.$route.query })
    }
    // this.channel_id = 	session.get("channel_id") == '' ? 1 : session.get("channel_id")
    this.nav_color = this.channel_id == 1 ? '#e62129' : this.channel_id == 2 ? '#1a4698' : '#5f5d5d'
    this.value = this.options[0].label
    this.valuelang = this.optionslang[0].labellang
    this.getParams()
    this.pcgetproductdetail()
    this.heshow = true

    sessionStorage.setItem('page', JSON.stringify({ name: 'pcdetails', data: this.$route.query }))
  },
  components: {
    detailContent,
    headers,
    footers,
    myVideo,
    positionBar,
    detailDownload,
    detailTips,
    specialEndo,
    specialPtE
  },
  // watch:{
  // '$route': 'getParams'
  // },
  mounted() {
    let that = this
    this.$nextTick(() => {
      this.is_mounted = true
      document.addEventListener('scroll', this.handleScroll, false)
      // let video = document.getElementById('bigvideo')
      // video.addEventListener('play',function(){
      // 	that.video_play = true
      // })
      // video.addEventListener('pause',function(){
      // 	that.video_play = false
      // })
      // video.addEventListener('ended',function(){
      // 	that.video_play = false
      // })
      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('scroll', this.handleScroll, false)
        // video.removeEventListener('play')
        // video.removeEventListener('puase')
        // video.removeEventListener('ended')
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.acindex = 1
    this.detailid = to.query.e
    this.pcgetproductdetail()
    next();
  },
  methods: {
    toYoutube() {
      window.open(utils.getYouUrl(this.youtube_id))
    },
    async downloadZip(sourceList, zipName = '文件夹名称') {
      const zip = new JSZip()
      const fileFolder = zip.folder(zipName) // 创建 zipName 文件夹
      const fileList = []
      for (let i = 0; i < sourceList.length; i++) {
        // const name = sourceList[i].picName // 注意: 每张图片的名称--需要对数据属性进行转换
        const name = zipName + '_' + (i + 1) // 注意: 每张图片的名称--需要对数据属性进行转换
        const image = new Image()
        image.setAttribute('crossOrigin', 'Anonymous') // 设置 crossOrigin 属性，解决图片跨域报错
        image.src = sourceList[i]
        image.onload = async () => {
          const url = await this.getImageBase64(image)
          fileList.push({ name: name, img: url.substring(22) }) // 截取 data:image/png;base64, 后的数据
          if (fileList.length === sourceList.length) {
            if (fileList.length) {
              for (let k = 0; k < fileList.length; k++) {
                // 往文件夹中，添加每张图片数据
                fileFolder.file(fileList[k].name + '.png', fileList[k].img, {
                  base64: true
                })
              }
              zip.generateAsync({ type: 'blob' }).then(content => {
                FileSaver.saveAs(content, zipName + '.zip')
              })
            }
          }
        }
      }
    },
    getImageBase64(image) {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, image.width, image.height)
      // 获取图片后缀名
      const extension = image.src
          .substring(image.src.lastIndexOf('.') + 1)
          .toLowerCase()
      // 某些图片 url 可能没有后缀名，默认是 png
      return canvas.toDataURL('image/' + extension, 1)
    },
    downloadImageAll(imageArr, fileName) {
      const _this = this
      imageArr.forEach((item, index) => {
        setTimeout(function () {
          _this.downloadImage(item.image, fileName + '_' + (index + 1))
        }, index * 100)

      })
      // var zip = new JSZip();
      // var count = 0;
      // imageArr.forEach((url, index) => {
      // 	var xhr = new XMLHttpRequest();
      // 	xhr.open("GET", url, true);
      // 	xhr.responseType = "blob";
      // 	xhr.onload = function () {
      // 		if (xhr.status === 200) {
      // 			var name = url.substring(url.lastIndexOf("/") + 1);
      // 			zip.file(name, xhr.response);
      // 		}
      // 		count++;
      // 		if (count === urls.length) {
      // 			zip.generateAsync({type:"blob"}).then(function(content) {
      // 				saveAs(content, "pictures.zip");
      // 				console.log("下载成功");
      // 			});
      // 		}
      // 	};
      // 	xhr.send();
      // });
      // this.downloadZip(imageArr,fileName)
    },
    downloadImage(url, fileName) {
      url = this.$utils.urlConversion(url)
      let a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
    },
    downloadFileAll(imageArr, fileName, type) {
      const _this = this
      imageArr.forEach((item, index) => {
        if (type == 1) {
          setTimeout(function () {
            _this.downloadFile(item.video, fileName + '_' + (index + 1))
          }, index * 100)
        }else {
          setTimeout(function () {
            _this.downloadFile(item.resource, fileName + '_' + (index + 1))
          }, index * 100)
        }
      })
    },
    downloadFile(url, fileName) {
      url = this.$utils.urlConversion(url)
      var name = fileName;
      // var suffix = url.substring(url.lastIndexOf("."), url.length);
      // //跳过浏览直接下载
      fetch(url)
          .then(res => res.blob())
          .then(blob => {
            const a = document.createElement("a");
            const objectUrl = window.URL.createObjectURL(blob);
            a.download = name;
            a.href = objectUrl;
            a.click();
            window.revokeObjectURL(objectUrl);
          })
    },
    switchTab(i) {
      window.scrollTo(0, 0);
      this.acindex = i
    },
    optionssvid() {
      document.getElementById('bigvideo').play()
    },
    handleScroll() {
      // let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
      // this.$refs.head.scrollTop_change(scrollTop)
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        // if(scrollTop>this.scroll_height){
        this.productc_nav = true
        // }else{
        // 	this.productc_nav = false
        // }
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    ChangeEmit() { //子组件传递
      //主动调用子组件
      this.$refs.is_change.get_index_channel_data();
      this.$refs.is_change.pageParam();
      this.pcgetproductdetail()
      this.pageParam()
    },
    pageParam() {
      let lang = session.get("lang");
      if (lang === "cn") {
        this.vidcenter = "产品使用说明书预览"
        this.videonavall = "产品使用说明书"
        this.casesha = "备注"
        this.networkco = "显示更多"
        this.value = '产品详情'
        this.xiangq = '产品详情'
        this.canshu = '产品参数'
        this.shuom = '产品说明'
        this.options =
            [{
              'value': '1',
              'label': '产品详情'
            }, {
              'value': '2',
              'label': '产品参数'
            }, {
              'value': '3',
              'label': '产品说明'
            }]
      } else {
        this.vidcenter = "Product manual Preview"
        this.videonavall = "Product instructions"
        this.casesha = "remarks"
        this.networkco = "Show more"
        this.value = 'product details'
        this.xiangq = 'Details'
        this.canshu = 'Specifications'
        this.shuom = 'Manual'
        this.options =
            [{
              'value': '1',
              'label': 'product details'
            }, {
              'value': '2',
              'label': 'Product parameters'
            }, {
              'value': '3',
              'label': 'Product description'
            }]
      }
    },
    navtoshiyan(src) {
      window.open(src)
      // let e= this.filenavto
      // console.log(e)
      // this.$router.push({path: '/pcshiyan',query:{e}})
    },
    pcgetproductdetail() {
      this.showProduct = false
      const channelId = session.get("channel_id") == '' ? 1 : session.get("channel_id")
      let data = {
        lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
        channel_id: channelId,
        id: this.detailid,
        mold: "pc",
      }
      this.$api.get_product_detail(data).then((res) => {
        console.log(res.data.channel_ids)
        // if (this.pageType == 'scan' && res.data.channel_ids) {
        //   let channel_ids = res.data.channel_ids.split(',')
        //   if (channel_ids.indexOf(this.channel_id) == -1) {
        //     this.channel_id = channel_ids.length > 1 ? channel_ids.sort((a, b) => a - b)[0] : channel_ids[0]
        //
        //     this.$refs.head.setChannel(this.channel_id, true)
        //     if (this.channel_id == 1) {
        //       this.$store.commit('setthemeColor', '#e62129')
        //       this.$store.commit('setBrand', 'woodpecker')
        //       this.$store.commit('setthemeArrow', require('../../assets/pchomeimg/playne.svg'))
        //     } else if (this.channel_id == 2) {
        //       this.$store.commit('setthemeColor', '#1a4698')
        //       this.$store.commit('setBrand', 'dte')
        //       this.$store.commit('setthemeArrow', require('../../assets/pchomeimg/playne-arrow-dte.svg'))
        //     } else {
        //       this.$store.commit('setthemeColor', '#000000')
        //       this.$store.commit('setBrand', 'dba')
        //       this.$store.commit('setthemeArrow', require('../../assets/pchomeimg/playne-arrow-dba.svg'))
        //     }
        //   }
        // }

        let channel_ids = res.data.channel_ids.split(',')
        if (channel_ids.indexOf(this.channel_id) == -1) {
          this.channel_id = channel_ids.length > 1 ? channel_ids.sort((a, b) => a - b)[0] : channel_ids[0]

          this.$refs.head.setChannel(this.channel_id, true)
          if (this.channel_id == 1) {
            this.$store.commit('setthemeColor', '#e62129')
            this.$store.commit('setBrand', 'woodpecker')
            this.$store.commit('setthemeArrow', require('../../assets/pchomeimg/playne.svg'))
          } else if (this.channel_id == 2) {
            this.$store.commit('setthemeColor', '#1a4698')
            this.$store.commit('setBrand', 'dte')
            this.$store.commit('setthemeArrow', require('../../assets/pchomeimg/playne-arrow-dte.svg'))
          } else {
            this.$store.commit('setthemeColor', '#000000')
            this.$store.commit('setBrand', 'dba')
            this.$store.commit('setthemeArrow', require('../../assets/pchomeimg/playne-arrow-dba.svg'))
          }
        }



        this.detail = res.data
        this.youtube_id = res.data.video_id
        this.detailnames = res.data.name
        this.positionNav[2].title = this.detailnames
        this.parameter = res.data.top_image
        this.htmlcontent = res.data.content

        this.productargcont = res.data.productarg
        this.fiilecontent = res.data.file_content
        this.filetitle = res.data.file_title
        this.filenavto = res.data.producfile
        this.channel_file = res.data.channel_file
        this.resource = res.data.resource
        this.detavideo = res.data.video
        this.poster = res.data.image
        this.contenttitle = res.data.title_content.split('\n')
        this.detavideosea = this.detavideo ? true : false
        this.publicize.video = res.data.en_video_data ? JSON.parse(res.data.en_video_data) : []
        this.publicize.resource = res.data.en_resource_data ? JSON.parse(res.data.en_resource_data) : []
        this.publicize.images = res.data.en_images_data ? JSON.parse(res.data.en_images_data) : []
        this.detail.en_video_data = res.data.en_video_data ? JSON.parse(res.data.en_video_data) : []

        let parsedResourceData = res.data.en_resource_data ? JSON.parse(res.data.en_resource_data) : []
        parsedResourceData.sort((a, b) => (b.sort || 0) - (a.sort || 0))
        this.detail.en_resource_data = parsedResourceData

        this.detail.en_images_data = res.data.en_images_data ? JSON.parse(res.data.en_images_data) : []

        this.detail.en_video_data.forEach(item => item.active = false)

        this.detail.en_resource_data.forEach(item => item.active = false)
        this.detail.en_images_data.forEach(item => item.active = false)
        this.showProduct = true
      });
    },

    hometo() {
      this.$router.push({ path: '/pchome' })
    },
    videoto() {
      this.$router.push({ path: '/pcvideos' })
    },
    queryto() {
      this.$router.push({ path: '/pcquerys' })
    },
    productto() {
      this.$router.push({ path: '/pcproduct' })
    },
    elitesto() {
      this.$router.push({ path: '/pcelites' })
    },
    contactusto() {
      this.$router.push({ path: '/pccontactus' })
    },
    aboutto() {
      this.$router.push({ path: '/pcabout' })
    },
    seachto() {
      this.$router.push({ path: '/pcseachs' })
    },
    nextimg() {
      let l = this.list_img.length;
      let scroll = document.getElementById('scroll-x');
      let diatance = scroll.scrollWidth - scroll.clientWidth;
      if (this.current_index == 0) {
        this.current_index = l - 1;
        scroll.scrollLeft = diatance;
      } else {
        this.current_index--;
        scroll.scrollLeft -= diatance / (l - 1);
      }
    },
    preimg() {
      let l = this.list_img.length;
      let scroll = document.getElementById('scroll-x');
      let diatance = scroll.scrollWidth - scroll.clientWidth;
      if (this.current_index + 1 == l) {
        this.current_index = 0;
        scroll.scrollLeft = 0;
      } else {
        this.current_index++;
        scroll.scrollLeft += diatance / (l - 1);
      }
    },
    enter(index) {
      this.navheader = true;
    },
    playenterli() {
      this.playli = false
    },

    playenterri() {
      this.playri = false
    },
    playleaveli() {
      this.playli = true
    },
    playleaveri() {
      this.playri = true
    },
    getParams() {
      this.detailid = this.$route.query.e
      this.pageType = this.$route.query.type
      if(this.$route.query.download){
        this.switchTab(3)
      }
      if (this.is_mounted) {
        this.$router.go(0)
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background: #fff;
}
.bcg{
  background-color: #f3f0f0a6;
}
.image_title{
  text-align: center;
  font-size: 24px;
  margin-top: 25%;
}
.bex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  box-sizing: border-box;
}
.bex_txt {
  overflow-wrap: break-word;
  word-break: break-all;
  width: 170px;
  margin-top: 14px;
}

.pcdetails {
  width: calc(100vw);
  height: calc(100vh);
  /* overflow-x: hidden; */
  position: relative;
  background: #fff;
}

.pchome-headerdet {
  width: 100vw;
  position: relative;
  background-size: 100% 100%;
  padding-top: 79px;
  box-sizing: border-box;
}

/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0;

	} */
.nav-wit {}

.nav-left {
  min-width: 100px;
  height: 50px;
}

.nav-left img {
  width: 100px;
  height: 50px;
}

/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */

.nav-center-item:first-child {
  margin-left: 0;
}

.nav-right {
  min-width: 210px;
  display: flex;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin-left: 170px;
}

.nav-right .search {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.nav-right .search img {
  width: 100%;
  height: 100%;
}

.nav-right .homename {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
}

.nav-right .homename img {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

.nav-right .language {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-right .language img {
  width: 16px;
  height: 16px;
  margin-left: 6px;
}

.checse {
  margin-top: 0 !important;
}

.product-title {
  color: #fff;
  margin-top: 249px;
  margin-left: 240px;
}

.title-hea {
  font-size: 20px;
  font-weight: normal;
  letter-spacing: 1px;
}

.title-model {
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 44px;
  font-weight: normal;
  letter-spacing: 2px;
}

.product-but {
  margin-top: 40px;
  font-size: 16px;
  width: 110px;
  height: 46px;
  background: #E31E24;
  border-radius: 23px;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}

/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0;
	} */
.nav-wit {}

.nav-left {
  width: 100px;
  height: 50px;
}

.nav-left img {
  width: 100%;
  height: 100%;
}

/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */

.nav-center-item:first-child {
  margin-left: 0;
}

.nav-right {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin-left: 180px;
}

.nav-right .search {
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.nav-right .search img {
  width: 100%;
  height: 100%;
}

.nav-right .homename {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
}

.nav-right .homename img {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

.nav-right .language {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-right .language img {
  width: 16px;
  height: 16px;
  margin-left: 6px;
}

/* .bb{
		background: #FAFAFA;
		position: fixed;
		top: 0;
		z-index: 99;
	} */
.aboutitem-hea {
  margin-top: 80px;
  margin-bottom: 40px;
  height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 33px;
  letter-spacing: 1px;
}

.aboutitem-fooitem {
  margin-bottom: 10px;
}

.fooitem-left {
  width: 110px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  display: flex;
  align-items: center;
  justify-content: center;


  font-size: 16px;
  font-weight: 400;
  color: #FAFAFA;
  margin-right: 20px;
}

.fooitem-left img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.aboutitem-foosus {
  display: flex;
  margin-bottom: 20px;
}

.fooitem-right {
  font-size: 16px;
  font-weight: 400;
  color: #CCCCCC;
}

.fooitem-cont {
  margin-top: 25px;
  margin-left: 40px;
}

.fooitem-cont:first-child {
  margin-left: 0px;
}

.fooite-img {
  display: flex;
}

.fooite-img img {
  width: 90px;
  height: 90px;
}

.fooite-nam {
  text-align: center;
  margin-top: 20px;
}

.right-tit {
  margin-bottom: 5px;
}

.homefoot {

  height: 94px;
  background: #272727;
  border-top: 2px solid #666;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.foot-hea {
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}

.foot-f {
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.productc {
  width: 1400px;
  /* height: 80px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 260px;
  background: rgba(255, 255, 255, .72);
  backdrop-filter: saturate(180%) blur(20px);
  z-index: 10000;

}

.productc-left {
  font-size: 14px;
  font-weight: 500;
  color: #5d5f5f;
  height: 40px;
  line-height: 40px;
}

.productc-right {
  font-size: 14px;
  font-weight: 400;
  color: #5d5f5f;
  display: flex;
}

.right-detail {
  margin-left: 24px;
  cursor: pointer;
}

.right-parameter {
  margin-left: 24px;
  margin-right: 0;
  cursor: pointer;
}

.right-instructions {
  margin-left: 24px;
  margin-right: 0;
  cursor: pointer;
}

.linesd {
  width: 100%;
  height: 1px;
  background: #EAEAEA;
}

.righttex {
  /* width: 1920px;
    height: 9921px; */
}

.righttex img {
  width: 100%;
  height: 100%;
}

.cc {
  color: #D03E3D;
}

.parametersea {
  width: 1400px;
  display: flex;
  flex-direction: column;
  padding: 0px 260px;

}

.parameter-header {
  display: flex;
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  margin-top: 60px;
  padding-bottom: 60px;
  border-bottom: #EAEAEA 1px solid;
}

.parahea-left {
  width: 380px;
  line-height: 1.8 !important;
}

.parahea-left p,
.parahea-left p span,
.parahea-left span {
  font-size: 18px;
  line-height: 1.8;
}

.parahea-leftname {
  font-size: 36px;
  font-weight: 500;
  color: #5d5f5f;
  letter-spacing: 1px;
}

.parahea-leftmodel {
  font-size: 30px;
  font-weight: 500;
  color: #5d5f5f;
  letter-spacing: 1px;
  margin-bottom: 30px;
}

.parahea-right {
  width: 920px;
  height: 500px;
  border-radius: 50px;
  margin-left: 100px;
  overflow: hidden;
}

.parahea-right img {
  width: 100%;
  height: 100%;
  transition: all .75s linear;
}

.parahea-right:hover img {
  cursor: pointer;
  transform: scale(1.02, 1.02);
}

.parameter-foo {
  padding: 60px 0;
  display: flex;
  border-bottom: #EAEAEA 1px solid;
}

.parafoo-left {
  width: 380px;
  font-size: 30px;
  font-weight: 500;
  color: #5d5f5f;
  letter-spacing: 1px;
}

.parafoo-right {
  font-weight: 400;
  color: #666666;
  margin-left: 100px;
}

.parafoo-right p,
.parafoo-right p span,
.parafoo-right span {
  font-size: 18px !important;
  line-height: 1.8 !important;
}

.instructions {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 80px;
}

.instructions-cont {
  width: 1000px;
  height: 320px;
  background: #FAFAFA;
  border-radius: 10px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.cont-hea {
  height: 40px;
  font-size: 28px;
  font-weight: 500;
  color: #5d5f5f;
  line-height: 40px;
}

.cont-but {
  height: 60px;
  background: #D03E3D;
  border-radius: 5px;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 27px;
  border: none;
  margin-top: 30px;
  box-sizing: border-box;
  cursor: pointer;
}

.cont-but img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.cont-title {
  height: 24px;
  font-size: 17px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 30px;
}

/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0;
	} */
.nav-wit {}

.nav-left {
  width: 100px;
  height: 50px;
}

.nav-left img {
  width: 100%;
  height: 100%;
}

/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */

.nav-center-item:first-child {
  margin-left: 0;
}

.nav-right {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin-left: 180px;
}

.nav-right .search {
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.nav-right .search img {
  width: 100%;
  height: 100%;
}

.nav-right .homename {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  cursor: pointer;
}

.nav-right .homename img {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

.nav-right .language {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-right .language img {
  width: 16px;
  height: 16px;
  margin-left: 6px;
}

.detailvideo {
  width: 1920px;
  height: 1080px;
  position: relative;
}

.detailvideo video {
  width: 100%;
  height: 100%;
}

.detailvideo .cover-container {
  position: relative;
  cursor: pointer;
}

.detailvideo .cover-container .icon-play {
  width: 70px;
  height: 70px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.productc_nav {
  position: fixed;
  top: 0%;
  background-color: #fff;
  background: rgba(255, 255, 255, .72);
  backdrop-filter: saturate(180%) blur(20px);
}

.html_div img {
  display: block;
}

.html_div p {
  margin: 0%;
}

.html_div {
  font-size: 24px;
}

.contright-icon {
  position: absolute;
  width: 78px;
  height: 78px;
  top: 50%;
  left: 50%;
  margin: -39px 0 0 -39px;
  cursor: pointer;
  display: flex;
}

.contright-icon img {
  width: 78px;
  height: 78px;
}

.download {}

.download .download-container {
  width: 1000px;
  margin: 0 auto;
  color: #666666;
  font-size: 20px;
  padding: 100px 0;
}

.download .download-container .publicize {
  display: flex;
  justify-content: space-between;
}

.download .download-container .publicize span {
  display: block;
  padding: 5px 10px;
}

.download .download-container .publicize span:first-child {
  padding-left: 0;
  padding-right: 0;
}

.download .download-container .publicize .download-btn,
.download .download-container .picture-list .item .download-btn {
  border: 1px solid #666666;
  border-radius: 50px;
  cursor: pointer;
  font-size: 12px;
  padding: 10px 20px;

}

.download .download-container .publicize .download-btn i,
.download .download-container .picture-list .item .download-btn i {
  margin-left: 5px;
}

.download .download-container .line {
  border: 1px solid #EAEAEA;
  margin: 30px 0;
}

.download .download-container .picture-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}

.download .download-container .picture-list .item {
  width: 320px;
  margin: 30px 0 0 18px;

}

.download .download-container .picture-list .item .image {
  width: 320px;
  height: 180px;
  border-radius: 20px;
  overflow: hidden;
}

.download .download-container .picture-list .item .image .svg {
  height: 100%;
  object-fit: contain;
}

.download .download-container .picture-list .item:nth-child(3n+1) {
  margin-left: 0;
}

.download .download-container .picture-list .item img {
  width: 100%;
  display: block;
}

.download .download-container .picture-list .item .download-btn {
  display: inline-block;
  padding: 10px 20px;
  margin-top: 15px;
}
</style>
